import axios from "axios";
import { toast } from "react-toastify";
import { check_token_expired_logout } from "../user/userAction";
import {
  GET_ALL_FAQS,
  GET_BUYING_CONTENT,
  GET_CONTACT_US_CONTENT,
  GET_FINALIZE_CONTENT,
  GET_HEADER_CONTENT,
  GET_INSERTBID_CONTENT,
  GET_NEWSLETTER_CONTENT,
  GET_PHOTO_GUIDE_CONTENT,
  GET_COLLECTIBLES_SHIPPING_CONTENT,
  GET_SELL_ITEM_CONTENT,
  GET_SELLING_CONTENT,
  GET_BLOG_SPOTLIGHT_CONTENT,
} from "./cmsTypes";
import apiClient from "../../api/apiClient";

const { REACT_APP_BASE_URL } = process.env;

export const get_top_image_how_it_works = async (token, question_type) => {
  try {
    const url = `${REACT_APP_BASE_URL}admin/list-content/${question_type}`;
    const HEADERS = {
      headers: {
        "x-access-token": token,
      },
    };
    const res = await axios.get(url, HEADERS);
    if (res.data && res.data.status) {
      return res.data.data;
    }
  } catch (error) {
    console.log("Error");
  }
};

export const create_faq_question = async (token, form_data, id, dispatch) => {
  try {
    const urlPath = id ? `admin/update-content/${id}` : `admin/add-content`;

    const res = await (id
      ? apiClient.put(urlPath, form_data)
      : apiClient.post(urlPath, form_data));

    if (res.data && res.data.status) {
      toast.success(res.data.message, {
        toastId: "addeditem1",
        autoClose: 2000,
      });
      return true;
    }
  } catch (error) {
    console.log("Error");
  }
};

export const get_all_faq_questions = async (token, question_type, dispatch) => {
  try {
    const urlPath = `admin/list-content/${question_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      if (question_type === "InsertBid_content") {
        dispatch({ type: GET_INSERTBID_CONTENT, payload: res.data.data });
      } else if (question_type === "newsletter_content") {
        dispatch({ type: GET_NEWSLETTER_CONTENT, payload: res.data.data });
      } else {
        dispatch({ type: GET_ALL_FAQS, payload: res.data.data });
      }
    }
  } catch (error) {
    console.log("Error");
  }
};

export const get_buying_content = async (token, content_type, dispatch) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_BUYING_CONTENT, payload: res.data.data });
      return res.data.data;
    }
  } catch (error) {
    console.log("Error");
  }
};

export const get_selling_content = async (token, content_type, dispatch) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_SELLING_CONTENT, payload: res.data.data });
      return res.data.data;
    }
  } catch (error) {
    console.log("Error");
  }
};

export const get_finalizing_content = async (token, content_type, dispatch) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_FINALIZE_CONTENT, payload: res.data.data });
      return res.data.data;
    }
  } catch (error) {
    console.log("Error");
  }
};

export const update_items_sequence = async (
  token,
  sequencearr,
  question_type,
  dispatch
) => {
  try {
    const urlPath = `admin/update-sequence/${question_type}`;

    const res = await apiClient.put(urlPath, sequencearr);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.error);
    console.log("Error");
  }
};

export const get_contact_us_content = async (token, content_type, dispatch) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_CONTACT_US_CONTENT, payload: res.data.data });
    }
  } catch (error) {
    toast.error(error.response.data.error);
    console.log("Error");
  }
};

export const get_sell_item_content = async (token, content_type, dispatch) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_SELL_ITEM_CONTENT, payload: res.data.data });
    }
  } catch (error) {
    toast.error(error.response.data.error);
    console.log("Error");
  }
};

export const get_photo_guide_content = async (
  token,
  content_type,
  dispatch
) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_PHOTO_GUIDE_CONTENT, payload: res.data.data });
    }
  } catch (error) {
    toast.error(error.response.data.error);
    console.log(error.response.data.error);
  }
};

export const get_collectibles_shipping_content = async (
  token,
  content_type,
  dispatch
) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({
        type: GET_COLLECTIBLES_SHIPPING_CONTENT,
        payload: res.data.data,
      });
    }
  } catch (error) {
    toast.error(error.response.data.error);
    console.log(error.response.data.error);
  }
};

export const get_header_content = async (token, content_type, dispatch) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_HEADER_CONTENT, payload: res.data.data });
    }
  } catch (error) {
    toast.error(error.response.data.error);
    console.log(error.response.data.error);
  }
};

export const get_blog_spotlight_content = async (
  token,
  content_type,
  dispatch
) => {
  try {
    const urlPath = `admin/list-content/${content_type}`;

    const res = await apiClient.get(urlPath);

    if (res.data && res.data.status) {
      dispatch({ type: GET_BLOG_SPOTLIGHT_CONTENT, payload: res.data.data });
    }
  } catch (error) {
    toast.error(error.response.data.error);
    console.log(error.response.data.error);
  }
};

export const upload_cms_photo = async (photo, token, dispatch) => {
  const formData = new FormData();

  photo.forEach((v) => {
    formData.append(`photos`, v);
  });
  formData.append("type", "cms/image");

  try {
    const urlPath = `add-item/mediaImage`;

    const res = await apiClient.post(urlPath, formData);

    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.error, { toastId: "editphotoerrr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    console.log("Error");
  }
};

export const upload_cms_video = async (video, token, dispatch) => {
  // dispatch(start_loading());
  try {
    const url = `${REACT_APP_BASE_URL}add-item/videoupload`;
    const HEADERS = {
      headers: {
        "Content-Type": "multipart/form-data",
        "x-access-token": token,
      },
    };
    const formData = new FormData();
    video.forEach((v) => {
      formData.append(`video`, v);
    });
    formData.append("type", "cms/video");

    const res = await axios.post(url, formData, HEADERS);
    if (res.data && res.data.status) {
      toast.success(res.data.message);
      return res;
    } else {
      toast.error(res.error, { toastId: "editvideoerrr", autoClose: 2000 });
      return false;
    }
  } catch (error) {
    toast.error(error.response.data.message);
    console.log("Error");
  } finally {
    // dispatch(stop_loading());
  }
};

export const upload_video_content = async (videoFile, token, dispatch) => {
  try {
    const formData = new FormData();
    formData.append("video", videoFile);
    
    const res = await apiClient.post("/add-item/videoupload", formData, {
      headers: { 
        "Authorization": `Bearer ${token}`,
        "Content-Type": "multipart/form-data" 
      },
    });
    return res.data; 
  } catch (error) {
    console.error("Video upload error:", error);
    toast.error("Video upload failed");
  }
};

export const assignItemsToCollection = async (itemIds, collectionName, token) => {
  try {
    const res = await apiClient.patch("items/assign-collection", {
      itemIds,
      collection_name: collectionName,
    });
    if (res.data.status) {
      toast.success(`${itemIds.length} item(s) added to "${collectionName}"`);
      return true;
    }
    toast.error("Failed to update items.");
    return false;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to assign collection.");
    return false;
  }
};